import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useSupplierContacts(supplierId: string | null) {
  const queryOptions = orpc.accountsPayable.supplierContacts.list.queryOptions({
    input: { supplierId: supplierId ?? '' },
  });

  const query = useQuery({
    ...queryOptions,
    enabled: !!supplierId,
  });

  return {
    ...query,
    contacts: query.data?.contacts ?? [],
  };
}

export function useToggleApRemittance(supplierId: string | null) {
  const queryClient = useQueryClient();

  return useMutation({
    ...orpc.accountsPayable.supplierContacts.toggleApRemittance.mutationOptions(),
    onSuccess: () => {
      if (supplierId) {
        queryClient.invalidateQueries(
          orpc.accountsPayable.supplierContacts.list.queryOptions({
            input: { supplierId },
          }),
        );
      }
    },
  });
}

export function useAddApRemittanceContact(supplierId: string | null) {
  const queryClient = useQueryClient();

  return useMutation({
    ...orpc.accountsPayable.supplierContacts.addApRemittanceContact.mutationOptions(),
    onSuccess: () => {
      if (supplierId) {
        queryClient.invalidateQueries(
          orpc.accountsPayable.supplierContacts.list.queryOptions({
            input: { supplierId },
          }),
        );
      }
    },
  });
}
